import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api, { arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import StatusBadge from "@/components/common/StatusBadge";
import EmptyState from "@/components/common/EmptyState";
import { TableSkeleton } from "@/components/common/Loading";
import Pagination from "@/components/common/Pagination";

const PAGE_LIMIT = 20;

export default function Campaigns() {
  const [rows, setRows] = useState(null);
  const [pagination, setPagination] = useState({ total: 0, page: 1, totalPages: 1 });
  const [page, setPage] = useState(1);

  const load = async (p = 1) => {
    const { data } = await api.get("/campaigns", { params: { page: p, limit: PAGE_LIMIT } });
    setRows(arr(data?.data));
    setPagination({ total: data.total, page: data.page, totalPages: data.totalPages });
  };

  useEffect(() => { load(1); }, []);

  const handlePage = (p) => { setPage(p); load(p); };

  return (
    <div className="space-y-6">
      <PageHeader title="Campaigns" subtitle="History of your review request campaigns" icon={Megaphone} />
      {!rows ? <TableSkeleton /> : rows.length === 0 ? (
        <EmptyState icon={Megaphone} title="No campaigns yet" description="Sending review requests will create campaign history here." />
      ) : (
        <div className="card-surface overflow-hidden p-0">
          <div className="overflow-x-auto scrollbar-thin">
            <table className="w-full min-w-[700px]">
              <thead><tr className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                <th className="px-4 py-3">Campaign</th><th className="px-4 py-3">Recipients</th><th className="px-4 py-3">Sent</th><th className="px-4 py-3">Failed</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Date</th>
              </tr></thead>
              <tbody className="divide-y divide-slate-50">
                {rows.map((c, i) => (
                  <tr key={c.id || c._id || i} className="text-sm">
                    <td className="px-4 py-3 font-semibold text-slate-800">{c.name}</td>
                    <td className="px-4 py-3 text-slate-600">{c.totalRecipients}</td>
                    <td className="px-4 py-3 text-green-600">{c.sent}</td>
                    <td className="px-4 py-3 text-red-600">{c.failed}</td>
                    <td className="px-4 py-3"><StatusBadge status={c.status === "completed" ? "published" : "scheduled"} /></td>
                    <td className="px-4 py-3 text-slate-500">{new Date(c.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="px-4 pb-4">
            <Pagination page={pagination.page} totalPages={pagination.totalPages} total={pagination.total} limit={PAGE_LIMIT} onPage={handlePage} />
          </div>
        </div>
      )}
    </div>
  );
}
